import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../App";
import DelphiMark from "../components/DelphiMark";
import "../styles.css";

// Microsoft four-square logo
function MsLogo({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 21 21" aria-hidden="true">
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}

export default function Login() {
  const { login, user } = useAuth();

  // Already signed in? Go straight to the app.
  if (user) return <Navigate to="/" replace />;

  return (
    <div className="ms-login-page">
      <div className="ms-card">
        <div className="ms-header">
          <MsLogo size={24} />
          <span className="ms-header-text">Microsoft</span>
        </div>
        <div className="ms-title">Sign in</div>
        <div className="ms-subtitle">to continue to <strong>Delphi</strong></div>

        <div className="ms-accounts">
          <button className="ms-account" onClick={() => login()}>
            <div className="ms-account-av">HC</div>
            <div className="ms-account-info">
              <div className="ms-account-name">Sign in with your Hardaway account</div>
              <div className="ms-account-email">Microsoft Entra ID</div>
            </div>
          </button>
        </div>

        <div className="ms-footer">
          <span>Hardaway Construction · only Hardaway accounts can sign in</span>
        </div>
      </div>

      <div className="ms-brand-strip">
        <div className="ms-brand-logo"><DelphiMark size={22} /></div>
        <div>
          <div className="ms-brand-title">Delphi</div>
          <div className="ms-brand-sub">by Hardaway Construction</div>
        </div>
      </div>
    </div>
  );
}